import React from 'react'
import { Text, useTheme } from 'react-native-paper'
import { useBaseTextStyle } from '../../ions/styles'
import { helpers } from '@linqpal/common-frontend'

const { composeStyle } = helpers

export const TextTitleSecondary = ({ style, small, bold, alignRight, ...props }) => {
  const { titleSecondary } = useBaseTextStyle()
  const { fonts, fontSizes, colors } = useTheme()
  return (
    <Text
      {...props}
      style={composeStyle(titleSecondary, {
        marginBottom: 12,
        color: colors.surface
      }, bold && fonts.bold, small && { fontSize: fontSizes.regular }, alignRight && { textAlign: 'right' }, style)}
    />
  )
}
